import { render, staticRenderFns } from "./main-sidebar.vue?vue&type=template&id=44c37b15"
import script from "./main-sidebar.vue?vue&type=script&lang=ts"
export * from "./main-sidebar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports